import type { ReactElement, SVGProps } from 'react';

type XirpIconProps = Omit<SVGProps<SVGSVGElement>, 'height' | 'width'> & {
  size?: number | string;
};

type XirpLogoProps = Omit<SVGProps<SVGSVGElement>, 'height' | 'width'> & {
  height?: number | string;
};

const XirpMark = (): ReactElement => (
  <>
    <path
      d="M0 14.4999C0 9.5333 0 7.05 0.935816 5.13976C1.83182 3.31078 3.31078 1.83182 5.13976 0.935816C7.05 0 9.5333 0 14.4999 0H27.5001C32.4667 0 34.95 0 36.8602 0.935816C38.6892 1.83182 40.1682 3.31078 41.0642 5.13976C42 7.05 42 9.5333 42 14.4999V27.5001C42 32.4667 42 34.95 41.0642 36.8602C40.1682 38.6892 38.6892 40.1682 36.8602 41.0642C34.95 42 32.4667 42 27.5001 42H14.4999C9.5333 42 7.05 42 5.13976 41.0642C3.31078 40.1682 1.83182 38.6892 0.935816 36.8602C0 34.95 0 32.4667 0 27.5001V14.4999Z"
      fill="var(--xirp-mark-background, currentColor)"
    />
    <path
      d="M28.1705 9.44981C30.2365 9.44981 31.2699 9.45052 31.9117 10.0924C32.5532 10.7343 32.5533 11.7678 32.5533 13.8336V14.9293C32.5533 16.9953 32.5536 18.0287 31.9117 18.6705C31.2699 19.3124 30.2365 19.3121 28.1705 19.3121H27.0748C26.6009 19.3121 26.1813 19.3119 25.8083 19.3039C25.3114 19.2933 25.063 19.288 24.8751 19.3634C24.6873 19.4389 24.5276 19.5986 24.2082 19.918L19.918 24.2082C19.5986 24.5276 19.4389 24.6873 19.3634 24.8751C19.288 25.063 19.2933 25.3114 19.3039 25.8083C19.3119 26.1813 19.3121 26.6009 19.3121 27.0748V28.1705C19.3121 30.2365 19.3124 31.2699 18.6705 31.9117C18.0287 32.5536 16.9953 32.5533 14.9293 32.5533H13.8336C11.7678 32.5533 10.7343 32.5532 10.0924 31.9117C9.45052 31.2699 9.44981 30.2365 9.44981 28.1705V27.0748C9.44981 25.0086 9.45049 23.9755 10.0924 23.3336C10.7343 22.6917 11.7674 22.691 13.8336 22.691H14.9293C15.4004 22.691 15.8178 22.6909 16.1891 22.6985C16.6854 22.7085 16.9336 22.7135 17.1211 22.6381C17.3087 22.5626 17.4682 22.403 17.7872 22.084L22.0844 17.7861C22.4033 17.4671 22.5627 17.3076 22.6382 17.1201C22.7136 16.9326 22.7086 16.6846 22.6985 16.1885C22.691 15.8173 22.691 15.4001 22.691 14.9293V13.8336C22.691 11.7674 22.6917 10.7343 23.3336 10.0924C23.9755 9.45049 25.0086 9.44981 27.0748 9.44981H28.1705Z"
      fill="var(--xirp-mark-foreground, var(--background-base))"
    />
    <path
      d="M27.2086 21.8658C30.1586 21.8661 32.5504 24.2585 32.5504 27.2086C32.5501 30.1585 30.1585 32.5501 27.2086 32.5504C24.2585 32.5504 21.8661 30.1586 21.8658 27.2086C21.8658 24.2584 24.2584 21.8658 27.2086 21.8658Z"
      fill="var(--xirp-mark-foreground, var(--background-base))"
    />
    <path
      d="M14.7916 9.44981C17.7417 9.44981 20.1333 11.8415 20.1334 14.7916C20.1334 17.7418 17.7418 20.1334 14.7916 20.1334C11.8415 20.1333 9.44981 17.7417 9.44981 14.7916C9.44995 11.8416 11.8416 9.44995 14.7916 9.44981Z"
      fill="var(--xirp-mark-foreground, var(--background-base))"
    />
  </>
);

export const XirpIcon = ({
  size = 16,
  ...props
}: XirpIconProps): ReactElement => (
  <svg
    aria-hidden="true"
    fill="none"
    height={size}
    viewBox="0 0 42 42"
    width={size}
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <XirpMark />
  </svg>
);

export const XirpLogo = ({
  height = 28,
  ...props
}: XirpLogoProps): ReactElement => (
  <svg
    aria-hidden="true"
    fill="none"
    height={height}
    viewBox="0 0 102.457 42"
    width="auto"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <XirpMark />
    <path
      d="M50 31.159L57.163 20.545L50.493 10.569H55.51L60.005 17.5L64.529 10.569H69.372L62.673 20.487L69.778 31.159H64.79L59.831 23.532L54.872 31.159H50Z"
      fill="currentColor"
    />
    <path
      d="M69.9119 31.159V16.717H74.0299V31.159H69.9119ZM71.9709 14.397C70.5499 14.397 69.5349 13.411 69.5349 12.106C69.5349 10.801 70.5499 9.815 71.9709 9.815C73.3629 9.815 74.3779 10.801 74.3779 12.106C74.3779 13.411 73.3629 14.397 71.9709 14.397Z"
      fill="currentColor"
    />
    <path
      d="M76.1865 31.159V16.717H80.2466V20.748C80.9426 18.341 82.1316 16.369 84.1906 16.369C84.7996 16.369 85.2346 16.514 85.4376 16.63L86.0175 20.748C85.6695 20.516 84.9735 20.313 84.2195 20.313C81.9285 20.313 80.6816 22.517 80.3046 24.663V31.159H76.1865Z"
      fill="currentColor"
    />
    <path
      d="M96.0769 31.565C93.2349 31.565 91.6979 29.912 90.7699 28.259V36.785H86.6809V16.717H90.7699V19.646C91.6979 17.964 93.2639 16.282 96.0479 16.282C99.7889 16.282 102.457 19.559 102.457 23.938C102.457 28.317 99.8179 31.565 96.0769 31.565ZM94.9749 28.056C96.9759 28.056 98.3389 26.432 98.3389 23.938C98.3389 21.444 96.9759 19.762 94.9749 19.762C92.8869 19.762 91.3499 21.676 90.6829 23.909C91.3499 26.142 92.8869 28.056 94.9749 28.056Z"
      fill="currentColor"
    />
  </svg>
);
